import { IMAGE_LOADER, ImageLoaderConfig } from '@angular/common';
import { EnvironmentProviders, Inject, makeEnvironmentProviders } from '@angular/core';
import { DOMAIN_NUMBER_STR } from '@bcf-v2-platforms/platform-worker/common';
import { BCF_PRODUCTION_MODE, BCF_RELEASE_VERSION } from '../app/token';
import { IMG_WEB_CONFIG } from './token';
import { ImgWebConfig } from './types';

export function provideImgWebLoader(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: IMAGE_LOADER,
      useFactory:
        (imgWebConfig: ImgWebConfig, isProductionMode: boolean, domainNumberStr: string, releaseVersion: string) =>
        (config: ImageLoaderConfig) => {
          const hostUrl: string = isProductionMode ? imgWebConfig.hostUrlProd : imgWebConfig.hostUrlDev;
          const src: string = `${hostUrl}get-webp/?url=${config.src}&v=${releaseVersion}`;
          return src.replace('{apiVersion}', domainNumberStr);
        },
      deps: [
        [new Inject(IMG_WEB_CONFIG)],
        [new Inject(BCF_PRODUCTION_MODE)],
        [new Inject(DOMAIN_NUMBER_STR)],
        [new Inject(BCF_RELEASE_VERSION)]
      ]
    }
  ]);
}
